<form [formGroup]="form">
  <h2>Nome</h2>
  <mat-form-field class="name" appearance="outline" floatLabel="always">
    <input type="text" matInput [formControl]="form.controls.name" placeholder="Nome tipo percorso">
  </mat-form-field>
  <h2>Select avatar</h2>
  <app-system-avatar-selector [control]="form.controls.avatarId"></app-system-avatar-selector>
</form>
